import { useEffect, useState } from 'react';
import {
  MenuItem,
  Grid,
  InputLabel,
  FormControl,
  TextField,
} from '@mui/material';
import Select from '@mui/material/Select';
import { uploadFiles as uploadFilesAPI } from 'src/api/files/uploadFiles';

import { TenantsFormControl } from 'src/components/form/TenantsFormControl';
import { ContestStatus, GameTypeEnum } from 'src/enums/contest.enum';
import { CompetitionFormControl } from 'src/components/form/CompetitionFormControl';
import { ImageField } from 'src/components/form/ImageField';
import { AnyFieldApi } from '@tanstack/react-form';

interface ContestSettingsProps {
  form: any;
}

const defaultValues = {
  file: null,
  validate: false,
  name: 'tile_image',
};

export const ContestSettings = ({ form }: ContestSettingsProps) => {
  const [image, setImage] = useState<{
    file: File | null;
    validate: boolean;
  }>(defaultValues);

  const checkUploadFile = async (event: any) => {
    if (event.target.files.length > 0) {
      const files = event.target.files;

      const img = new Image(),
        url = window.URL || window.webkitURL;
      const img_size = {
        width: 0,
        height: 0,
      };
      img.onload = () => {
        img_size.width = img.width;
        img_size.height = img.height;
        setImage({
          file: event.target.files[0],
          validate: Boolean(img_size.width === 600 && img_size.height === 180),
        });

        // Validation
        if (img_size.width !== 600 && img_size.height !== 180) {
          throw new Error(
            'The image of the card is incorrect. The size should be 600x180'
          );
        }
      };
      img.src = url.createObjectURL(files[0]);
    }
  };

  useEffect(() => {
    if (!!image.validate && !!image.file) {
      const uploadFiles = async () => {
        try {
          const result = await uploadFilesAPI([image.file!], '');
          form.setFieldValue('tile_image', result.urls[0]);
        } catch (error) {
          console.error('Upload error:', error);
        }
      };
      uploadFiles();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [image]);

  return (
    <>
      <Grid item xs={4}>
        <form.Field
          name='competition_id'
          children={({ state, handleChange }: AnyFieldApi) => (
            <CompetitionFormControl
              value={state.value}
              onChange={(e) => handleChange(e.target.value)}
            />
          )}
        />
      </Grid>
      <Grid item xs={4}>
        <form.Field
          name='game_type'
          children={({ state, handleChange }: AnyFieldApi) => (
            <FormControl fullWidth>
              <InputLabel id='game_type-label'>Game Type</InputLabel>
              <Select
                labelId='game_type-label'
                value={state.value}
                label='Game Type'
                onChange={(e) => handleChange(e.target.value)}
              >
                <MenuItem value={GameTypeEnum.PRIVATE}>Private</MenuItem>
                <MenuItem value={GameTypeEnum.PUBLIC}>Public</MenuItem>
              </Select>
            </FormControl>
          )}
        />
      </Grid>
      <Grid item xs={2}>
        <form.Field
          name='prize_pool'
          children={({ state, handleChange, handleBlur }: AnyFieldApi) => (
            <TextField
              id='prize_pool'
              label='Prize Pool'
              fullWidth
              type='number'
              value={state.value}
              onChange={(e) => handleChange(e.target.value)}
              onBlur={handleBlur}
            />
          )}
        />
      </Grid>
      <Grid item xs={2}>
        <form.Field
          name='currency'
          children={({ state, handleChange, handleBlur }: AnyFieldApi) => (
            <TextField
              id='currency'
              label='Currency'
              fullWidth
              value={state.value}
              onChange={(e) => handleChange(e.target.value)}
              onBlur={handleBlur}
            />
          )}
        />
      </Grid>
      <Grid item xs={4}>
        <form.Field
          name='status'
          children={({ state, handleChange }: AnyFieldApi) => (
            <FormControl fullWidth>
              <InputLabel id='status-label'>Status</InputLabel>
              <Select
                labelId='status-label'
                value={state.value}
                label='Type'
                onChange={(e) => handleChange(e.target.value)}
              >
                <MenuItem value={ContestStatus.Draft}>DRAFT</MenuItem>
                <MenuItem value={ContestStatus.Active}>ACTIVE</MenuItem>
              </Select>
            </FormControl>
          )}
        />
      </Grid>

      <Grid item xs={4}>
        <form.Field
          name='tenant'
          children={({ state, handleChange }: AnyFieldApi) => (
            <>
              {/* TODO change to multiple tenants when backend fix */}
              <TenantsFormControl
                value={state.value.split(',')}
                onChange={(value) => {
                  handleChange(
                    typeof value === 'string' ? value : value.join(',')
                    //     typeof value === 'string' ? value.split(',') : value
                  );
                }}
              />
            </>
          )}
        />
      </Grid>

      <Grid item xs={4}>
        <form.Field
          name='tile_image'
          children={({ state, name }: AnyFieldApi) => {
            return (
              <ImageField
                value={state.value}
                onChange={(event) => checkUploadFile(event)}
                onRemove={() => form.setFieldValue(name, '')}
                label='Tile Image'
                name={name}
              />
            );
          }}
        />
      </Grid>
    </>
  );
};
